// extracted by mini-css-extract-plugin
export default {"needPremium":"NeedPremium_needPremium__uXb2o","title":"NeedPremium_title__o4Nj+"};